import React from 'react';
import { getEditorPreloader } from '@confluence-classic/confluence-fabric-editor/src/lib/index.ts';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { GoToHomeLoader } from '@confluence/home-redirects/entry-points/GoToHome.ts';
import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';
import type { IEditorPreloader } from '@confluence/edit-button/entry-points/types.ts';

export const HomeRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ name }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				attributes: {
					navdexPointType: string;
				};
			};
			pageState: {
				routeName: string;
			};
		};
		MainLayout: {
			navView: string;
			editorPreloader: () => Promise<() => (config: IEditorPreloader) => JSX.Element>;
		};
	};
} = (): React.JSX.Element => <GoToHomeLoader />;

HomeRoute.NAVIGATION_PARAMS = ({
	name,
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			attributes: {
				navdexPointType: string;
			};
		};
		pageState: {
			routeName: string;
		};
	};
	MainLayout: {
		navView: string;
		editorPreloader: () => Promise<() => (config: IEditorPreloader) => JSX.Element>;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'homeScreen',
			attributes: {
				navdexPointType: START_TOUCH,
			},
		},
		pageState: { routeName: name },
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
		editorPreloader: getEditorPreloader,
	},
});
